import React from "react";
import { COMPANY } from "../data/site";

export const WhatsAppCTA = () => {
  return (
    <a
      href={COMPANY.whatsapp_link}
      target="_blank"
      rel="noopener noreferrer"
      data-testid="floating-whatsapp"
      aria-label="WhatsApp Sales"
      className="fixed bottom-6 right-6 z-40 w-14 h-14 bg-[#25D366] hover:bg-[#1ebe5d] shadow-[0_10px_28px_-12px_rgba(15,23,42,0.35)] flex items-center justify-center transition-colors"
    >
      <svg viewBox="0 0 24 24" fill="white" className="w-7 h-7">
        <path d="M20.52 3.48A12 12 0 0 0 3.48 20.52L2 22l1.52-1.52A12 12 0 1 0 20.52 3.48zM12 21.5c-1.7 0-3.3-.4-4.8-1.2l-.3-.2-3 .8.8-2.9-.2-.3A9.5 9.5 0 1 1 21.5 12 9.5 9.5 0 0 1 12 21.5z"/>
        <path d="M17.4 14.4c-.3-.15-1.77-.87-2.04-.97-.27-.1-.47-.15-.66.15-.2.3-.76.97-.93 1.17-.17.2-.34.22-.64.07-.3-.15-1.26-.46-2.4-1.48-.89-.79-1.49-1.77-1.66-2.07-.17-.3-.02-.46.13-.61.13-.13.3-.34.45-.51.15-.17.2-.3.3-.5.1-.2.05-.37-.02-.52-.07-.15-.66-1.6-.91-2.19-.24-.58-.49-.5-.66-.51-.17-.01-.37-.01-.57-.01-.2 0-.52.07-.79.37-.27.3-1.04 1.02-1.04 2.49 0 1.47 1.07 2.89 1.22 3.09.15.2 2.1 3.2 5.08 4.49.71.31 1.26.49 1.69.63.71.23 1.36.2 1.87.12.57-.08 1.77-.72 2.02-1.42.25-.7.25-1.3.17-1.42-.07-.12-.27-.2-.57-.35z"/>
      </svg>
    </a>
  );
};

export default WhatsAppCTA;
